import { pluralize } from '@libs/i18n';

export type Props = {
  className?: string;
  cnt?: number;
  zero?: string;
  one: string;
  few?: string;
  many: string;
};

export function Plural({ className, cnt, zero, one, few, many }: Props) {
  const result = pluralize({ zero, one, few, many }, cnt);
  return <span className={className}>{result}</span>;
}
